// import React, { useState, useEffect } from "react";
// import "./Sidebar.css"; // Assuming you have a separate CSS file for styling
// import ItemPathFilter from "../FilterSidebar/ItemPathFilter";

// function Sidebar() {
//   const [sidebarWidth, setSidebarWidth] = useState("15vw");
//   // const [sidebarVisible, setSidebarVisible] = useState(true);

//   const handleSidebarResize = (event) => {
//     setSidebarWidth(event.clientX);
//   };

//   // const toggleSidebar = () => {
//   //   setSidebarVisible(!sidebarVisible);
//   // };

//   useEffect(() => {
//     const handleMouseMove = (event) => {
//       if (event.buttons === 1) {
//         handleSidebarResize(event);
//       }
//     };

//     window.addEventListener("mousemove", handleMouseMove);

//     return () => {
//       window.removeEventListener("mousemove", handleMouseMove);
//     };
//   }, []);

//   const handleMouseEnter = () => {
//     document.body.style.cursor = "col-resize";
//   };

//   const handleMouseLeave = () => {
//     document.body.style.cursor = "auto";
//   };

//   return (
//     <div>
//       <div className="container">
//         {(
//           <div
//             className="sidebar"
//             style={{ width: sidebarWidth }}
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//           >
//             <ItemPathFilter />
//             {/* <button className="tgbtn" onClick={toggleSidebar}>
//               {sidebarVisible ? "<<" : ">>"}
//             </button> */}
//           </div>
//         )}

//         {/* <div className="header">
//           <button className="tgbtn" onClick={toggleSidebar}>
//             {sidebarVisible ? "<<" : ">>"}
//           </button>
//           <button style={{ marginLeft: "20px" }}>My Favorites</button>
//         </div> */}
//       </div>
//     </div>
//   );
// }

// export default Sidebar;

// ===================================

















import React from "react";
import { useState, useEffect, useRef } from "react";
import "./Sidebar.css";
import ItemPathFilter from "../FilterSidebar/ItemPathFilter";
import MenuTreeStructure from "../../../../Components/MenuTreeStructure/MenuTreeStructure";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

function Sidebar({ setPagePath, setRoutes }) {
  const sidebarRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(268);

  const startResizing = React.useCallback((mouseDownEvent) => {
    setIsResizing(true);
  }, []);

  const stopResizing = React.useCallback(() => {
    setIsResizing(false);
  }, []);

  const resize = React.useCallback(
    (mouseMoveEvent) => {
      if (isResizing) {
        setSidebarWidth(
          mouseMoveEvent.clientX -
            sidebarRef.current.getBoundingClientRect().left
        );
      }
    },
    [isResizing, sidebarRef]
  );

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", resize);
      window.addEventListener("mouseup", stopResizing);
    } else {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    }
    // Clean up event listeners when component unmounts
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, resize, stopResizing]);

  return (
    <>
    


      
      {/* FIXED ItemPathFilter AND OVERFLOW MenuTreeStructure ON DATE - 11/21/202*/}
      <div
        ref={sidebarRef}
        className="app-sidebar"
        style={{ width: sidebarWidth }}
      >
        <div className="sidebar-header-fixed">
          <ItemPathFilter setPagePath={setPagePath} />
        </div>

        <div className="sidebar-scroll-content">
          <MenuTreeStructure setPagePath={setPagePath} setRoutes={setRoutes} />
        </div>
      </div>
    </>
  );
}

export default Sidebar;
